<h3 class="title-h3">{{'bookingPayment.title.paymentWithMBWay' | ibeadmin | async}}</h3>
<p>{{'bookingPayment.text.enterMobileNumber' | ibeadmin | async}}</p>

<div class="container no-pad-bottom no-pad-h" *ngIf="hasMilesPayable">
	<app-notification [style]="'information'" [icon]="'icons.svg#general--information'"
	[title]="'bookingPayment.title.milesRedemption' | ibeadmin | async">
		<div message>
			<span>
				{{'bookingPayment.text.pleaseNoteMilesRedeem' | ibeadmin | async}}
			</span>
		</div>
	</app-notification>
</div>

<div class="container no-pad-bottom no-pad-h">
	<app-notification [style]="'information'" [icon]="'icons.svg#general--timer'"
		[title]="'bookingPayment.text.validForPayment' | ibeadmin | async">
		<div message>
			<span>
				{{'bookingPayment.text.yourBookingWillBeValid' | ibeadmin | async}} 
				<span class="bold">{{'bookingPayment.text.mbWay' | ibeadmin | async}} </span> 
				{{'bookingPayment.text.accountForTheNext' | ibeadmin | async}} 
				<span class="bold">{{'bookingPayment.text.tenMinutes' | ibeadmin | async}}</span>. 
				{{'bookingPayment.text.pleaseConfirmTheAmount' | ibeadmin | async}} 
				<span class="bold">{{'bookingPayment.text.dailyLimit' | ibeadmin | async}}</span> 
				{{'bookingPayment.text.toChangeThisLimit' | ibeadmin | async}}
			</span>
		</div>
	</app-notification>
</div>

<form [formGroup]="form" >
	<div class="phone-container">
		<label class="label" for="mb_way">{{'bookingPayment.text.phoneNumber' | ibeadmin | async}}</label>
		<div class="input-wrap">
			<span class="input-prefix">+351</span>
			<input formControlName="phoneNumber" 
				name="mb_way"
				class="input-text {{ hasErrorClassPhoneNumber }}"
				inputmode="numeric"
				type="text"
				id="mb_way" 
				[attr.aria-label]="'bookingPayment.aria.insertPhoneNumber' | ibeadmin | async"
				aria-required="true"
				autocomplete="false"
				pattern="[0-9]*" size="4" maxlength="9" appNumberOnly />
			<span 
				aria-live="polite"
				[attr.aria-label]="INDRA_formErrors('phoneNumber')"
				class="input-error" 
				role="alert" 
				*ngIf="form.controls['phoneNumber'].invalid && form.touched">
				{{ INDRA_formErrors('phoneNumber') }}
			</span>
		</div>
		<!--
		<div class="grid">
			<div class="col-3 col-tl-3 col-p-12 col-tp-12">
				<label class="label" for="phoneNumberPrefix">Country Code</label>
				<app-select-input-indra
					selectId="selectPhoneCountry"
					placeholder="Select Country Code Prefix"
					formControlName="phoneNumberPrefix"
					errorClass="{{hasErrorPhoneNumberPrefix}}"
					[options]="countryCodeOptions"
					selectLabel="Select Country Code Prefix">
				</app-select-input-indra>
				<span 
					aria-live="polite"
					[attr.aria-label]="INDRA_formErrors('phoneNumberPrefix')"
					class="input-error" 
					role="alert" 
					*ngIf="form.controls['phoneNumberPrefix'].invalid && form.touched">
					{{ INDRA_formErrors('phoneNumberPrefix') }}
				</span>
			</div>
			<div class="col-3 col-tl-3 col-p-12 col-tp-12">
				<label class="label" for="mb_way">Phone Number</label>
				<input formControlName="phoneNumber" 
					class="input-text {{ hasErrorClassPhoneNumber }}"
					inputmode="numeric"
					type="number"
					id="mb_way" 
					aria-required="true"/>
				<span 
					aria-live="polite"
					[attr.aria-label]="INDRA_formErrors('phoneNumber')"
					class="input-error" 
					role="alert" 
					*ngIf="form.controls['phoneNumber'].invalid && form.touched">
					{{ INDRA_formErrors('phoneNumber') }}
				</span>
			</div>
		</div>
		-->
	</div>
	<div class="payment-option__conditions-wrapper" [class.has-error]="!(formIsValid$ | async)">
		<div class="payment-option__conditions">
			<app-checkbox-input formControlName="accepted_conditions" label="" [class.has-error]="!(formIsValid$ | async)">
			</app-checkbox-input> 
			<span>
				{{'bookingPayment.text.haveReadInFullAndAccept' | ibeadmin | async}} 
				<a class="link" href="javascript:;"
					(click)="INDRA_handleBookingTicketConditions()" 
					[attr.aria-label]="'bookingPayment.aria.openFare' | ibeadmin | async" role="button">
					{{'bookingPayment.text.fareConditions' | ibeadmin | async}} 
				</a>
				{{'bookingPayment.text.andThe' | ibeadmin | async}} 
				<a class="link link--external" href="javascript:;"
					(click)="INDRA_gotoURL('externalURLs.transportConditions')"
					[attr.aria-label]="'bookingPayment.text.conditionsOfCarriage' | ibeadmin | async">
					{{'bookingPayment.text.conditionsOfCarriage1' | ibeadmin | async}} 
				</a> 
				<!--{{'bookingPayment.text.andThe' | ibeadmin | async}} 
				<a class="link link--external" href="javascript:;"
					(click)="INDRA_gotoURL('externalURLs.milesGoTermsConditions')">
					{{'bookingPayment.text.conditionsOfMilesGoProgramme' | ibeadmin | async}}
				</a>-->
				<ng-container *ngIf="displayCovidTermsAndCondition">
					, {{ 'bookingPayment.text.andAcceptCovidCondition' | ibeadmin | async }}
					<a class="link link--external" href="javascript:;"
						(click)="INDRA_gotoURL('externalURLs.canadaTravelMeasures')">
						{{ 'bookingPayment.text.termsConditions' | ibeadmin | async }}
					</a>
					{{ 'bookingPayment.text.covidCondition' | ibeadmin | async }}
				</ng-container>
			</span>
		</div>
	</div>
</form>


